module.exports = __webpack_public_path__ + "img/ICON_AGE_TOSOLA.a56149cf.png";